export const PAT_KEYS = {
  AngleRanking: 'AngleRanking',
  CubeCounting: 'CubeCounting',
  HolePunching: 'HolePunching',
  Keyhole: 'Keyhole',
  PatternFolding: 'PatternFolding',
} as const
